(() => {
  if (window.NTCSamplePilot) return;
  const configNode = document.getElementById('ntc-sample-config');
  if (!configNode) return;
  const rawConfig = JSON.parse(configNode.textContent);
  const cfg = {...rawConfig, ...rawConfig.eligibility};
  const root = window.Shopify?.routes?.root || '/';
  let campaign = rawConfig.campaign || 'sole-coco-131026';
  let attr = campaign === 'sole-coco-131026' ? 'ntc_coco_declined' : 'ntc_benefit_declined';
  let key = `ntc_sample_declined_${campaign}_${cfg.customerId}`;
  cfg.enabled = cfg.enabled !== false;
  cfg.priceCents = rawConfig.priceCents === 0 ? 0 : 1;
  cfg.minimumCents = 0;
  let benefit, settingsAt=0, settingsFlight;
  let managedVariants = new Set([cfg.variantId, ...(rawConfig.managedVariantIds || [])]);
  const nativeFetch = window.fetch.bind(window);
  const ownCodes = (cfg.legacyCodes || []).map(code => code.toUpperCase());
  let eligibilityCheckedAt = Date.now();
  let busy = false, timer, lastCart = cfg.initialCart, state = 'hidden';
  let active = false, checkedAt = 0, membershipFlight, usedSharedStatus = false;
  let queued = false, pendingCart, revision = 0, blocked = false, previouslyPresent = false;
  const text = cfg.pl ? {
    added: 'Twój benefit klubowy — próbka za jeden grosz',
    detail: 'Sole di Coco · 1,5 ml · 0,01 zł · raz na konto',
    checking: 'Sprawdzamy Twój benefit klubowy…',
    adding: 'Dodajemy próbkę Sole di Coco…',
    removing: 'Usuwamy próbkę…',
    pendingDetail: 'Za chwilę potwierdzimy koszyk.',
    removed: 'Próbka została usunięta z koszyka',
    removedDetail: 'Nie dodamy jej ponownie automatycznie. Benefit wykorzystasz po zakupie.',
    add: 'Dodaj ponownie', remove: 'Usuń próbkę',
    failed: 'Nie udało się aktywować próbki za grosz',
    failedDetail: 'Sprawdź członkostwo i dostępność próbki. Możesz spróbować ponownie.',
    conflict: 'Próbka nie łączy się z obecnym rabatem',
    conflictDetail: 'Zachowaliśmy rabat na Twoje produkty. Próbka nie została dodana.',
    removeFailed: 'Nie udało się usunąć próbki',
    removeFailedDetail: 'Sprawdź połączenie i spróbuj ponownie.',
    retry: 'Spróbuj ponownie'
  } : {
    added: 'Your club benefit — a sample for PLN 0.01',
    detail: 'Sole di Coco · 1.5 ml · PLN 0.01 · once per customer',
    checking: 'Checking your club benefit…', adding: 'Adding your Sole di Coco sample…',
    removing: 'Removing the sample…', pendingDetail: 'Confirming your cart shortly.',
    removed: 'The sample was removed from your cart',
    removedDetail: 'We will not add it again automatically. The benefit is redeemed after purchase.',
    add: 'Add again', remove: 'Remove sample',
    failed: 'The sample benefit could not be applied',
    failedDetail: 'Check your membership and sample availability, then try again.',
    conflict: 'The sample cannot combine with your current discount',
    conflictDetail: 'We kept your product discount. The sample was not added.',
    removeFailed: 'The sample could not be removed',
    removeFailedDetail: 'Check your connection and try again.', retry: 'Try again'
  };
  Object.assign(text, rawConfig.copy || {});
  function applyHistory() {
    if (!cfg.useApp || !benefit) return;
    const h=cfg.history || {}, orders=Array.isArray(h.orders)?h.orders:[];
    const ids=new Set(benefit.usedProductIds || [benefit.product.id]);
    cfg.used=orders.some(order=>(order.productIds||[]).some(id=>ids.has(id)) || benefit.id==='sole-coco-131026' && (order.discounts||[]).some(code=>ownCodes.includes(code))) || benefit.id==='sole-coco-131026' && h.pilotTagUsed===true;
    const productStarts = {10952276181331: Date.UTC(2026,9,13), 10966024946003: Date.UTC(2026,9,15)};
    const knownStart = [...ids].every(id=>productStarts[id]) ? Math.min(...[...ids].map(id=>productStarts[id])) : 0;
    cfg.historyComplete=Number.isInteger(h.ordersCount) && (h.ordersCount<=orders.length || knownStart>0 && orders.some(order=>order.createdAt<knownStart));
  }
  function appSettings(force=false) {
    if (!cfg.useApp) return Promise.resolve();
    if (settingsFlight) return settingsFlight;
    if (!force && Date.now()-settingsAt<15000) return Promise.resolve();
    settingsFlight=(async()=>{
      const url=new URL(rawConfig.benefitEndpoint);
      if (url.origin!=='https://nutu-ai-app.burbwrrr.workers.dev' || url.pathname!=='/api/benefits') throw Error('Invalid benefit endpoint');
      url.searchParams.set('theme_id',String(cfg.themeId));
      const response=await nativeFetch(url.toString(),{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(10000)});
      if (!response.ok) throw Error('Benefit settings unavailable');
      const data=await response.json();
      if (!Array.isArray(data.managedVariantIds)) throw Error('Invalid benefit settings');
      managedVariants=new Set([...managedVariants,...data.managedVariantIds.filter(Number.isSafeInteger)]);
      const next=data.active;
      if(next && (next.themeId!==String(cfg.themeId) || !Number.isSafeInteger(next.product?.variantId) || ![0,1].includes(next.product.priceCents) || next.product.currency!=='PLN')) throw Error('Invalid active benefit');
      if(benefit?.id!==next?.id || cfg.variantId!==next?.product?.variantId) {previouslyPresent=false;blocked=false;checkedAt=0;}
      benefit=next;
      cfg.enabled=rawConfig.enabled!==false && !!next;
      cfg.available=!!next;
      if(next) {
        campaign=next.id;attr=campaign==='sole-coco-131026'?'ntc_coco_declined':'ntc_benefit_declined';
        key=`ntc_sample_declined_${campaign}_${cfg.customerId}`;
        cfg.variantId=next.product.variantId;cfg.priceCents=next.product.priceCents;cfg.minimumCents=next.minimumCents;
        managedVariants.add(cfg.variantId);
        text.added=cfg.pl?next.titlePL:next.titleEN;
        text.detail=cfg.pl?next.detailPL:next.detailEN;
        text.adding=cfg.pl?'Dodajemy Twój benefit klubowy…':'Adding your club benefit…';
      }
      applyHistory();settingsAt=Date.now();
    })().finally(()=>{settingsFlight=null;});
    return settingsFlight;
  }
  function declineValue() {return campaign==='sole-coco-131026'?String(cfg.customerId):campaign+':'+cfg.customerId;}
  function fullCart(cart) {
    return cart && Array.isArray(cart.items) && typeof cart.total_price === 'number' && typeof cart.currency === 'string';
  }
  function declined(cart = lastCart) {
    try { if (localStorage.getItem(key) === '1') return true; } catch {}
    return Boolean(cfg.customerId) && String(cart?.attributes?.[attr] || '') === declineValue();
  }
  function remember(value) {
    try { if (value) localStorage.setItem(key, '1'); else localStorage.removeItem(key); } catch {}
  }
  function gift(line) { return managedVariants.has(line.variant_id) || line.variant_id !== cfg.legacyVariantId && Boolean(line.properties?._ntc_sample_campaign); }
  function legacyGift(line) { return line.variant_id === cfg.legacyVariantId && line.properties?._ntc_sample_campaign === 'sole-coco-131026'; }
  function otherProduct(cart) {
    const paid=cart.items.filter(line=>!gift(line) && !legacyGift(line) && line.final_line_price>0 && !/gift.?card/i.test(line.product_type || ''));
    return paid.length>0 && paid.reduce((sum,line)=>sum+line.final_line_price,0)>=cfg.minimumCents;
  }
  function codes(cart) {
    const result = new Set((cart.discount_codes || []).map(d => d.code).filter(Boolean));
    for (const line of cart.items || []) for (const a of line.line_level_discount_allocations || []) {
      if (a.discount_application?.type === 'discount_code') result.add(a.discount_application.title);
    }
    for (const a of cart.cart_level_discount_applications || []) if (a.type === 'discount_code') result.add(a.title);
    for (const code of result) if (ownCodes.includes(code.toUpperCase())) result.delete(code);
    return [...result].join(',');
  }
  function sectionsBody(body) {
    const sections = ['cart-items', 'cart-footer', 'cart-item-count', 'cart-live-region'];
    const giftSection = document.querySelector('[data-nt-gift-section-id]')?.dataset.ntGiftSectionId;
    if (giftSection && !sections.includes(giftSection)) sections.push(giftSection);
    return {...body, sections: sections.join(','), sections_url: window.location.pathname + window.location.search};
  }
  async function request(path, body) {
    const response = await nativeFetch(root + path, body ? {
      method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
    } : {credentials: 'same-origin', cache: 'no-store'});
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('Sample cart request failed');
    return result;
  }
  async function eligibility() {
    if (Date.now() - eligibilityCheckedAt < 60000) return;
    const url = new URL(root, window.location.origin);
    url.searchParams.set('section_id', 'ntc-sample-eligibility');
    url.searchParams.set('_ntc', String(Date.now()));
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await nativeFetch(url.toString(), {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(10000)});
    if (!response.ok) throw new Error('Sample eligibility unavailable');
    const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-ntc-sample-eligibility]');
    if (!node) throw new Error('Sample eligibility missing');
    const latest = JSON.parse(node.textContent);
    if (latest.customerId !== cfg.customerId) throw new Error('Customer account changed');
    Object.assign(cfg, latest);
    applyHistory();
    eligibilityCheckedAt = Date.now();
  }
  function membership() {
    if (!cfg.customerId) return Promise.resolve(false);
    if (Date.now() - checkedAt < 60000) return Promise.resolve(active);
    if (membershipFlight) return membershipFlight;
    membershipFlight = (async () => {
      await appSettings();
      await eligibility();
      if (!cfg.enabled || !cfg.tagEligible || !cfg.subscribed || cfg.used || !cfg.historyComplete) return false;
      let data;
      if (!usedSharedStatus && window.NTCStatus?.fresh) {
        usedSharedStatus = true;
        data = await window.NTCStatus.fresh();
      }
      if (!data?.membership) {
        const url = '/apps/nous-loyalty/api/customer/loyalty-status?shop=' + encodeURIComponent(cfg.shop) + '&customerId=' + encodeURIComponent(cfg.customerId);
        const response = await nativeFetch(url, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000)});
        if (!response.ok) throw new Error('Club status unavailable');
        data = await response.json();
      }
      active = data?.membership === 'active';
      checkedAt = Date.now();
      return active;
    })().finally(() => { membershipFlight = null; });
    return membershipFlight;
  }
  function cartFromResponse(response) {
    if (fullCart(response)) return response;
    const html = response?.sections?.['cart-items'];
    if (!html) return null;
    try {
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ntc-cart-state]');
      const cart = JSON.parse(node.textContent);
      return fullCart(cart) ? {...cart, sections:response.sections} : null;
    } catch { return null; }
  }
  function render() {
    document.querySelectorAll('[data-ntc-sample-card]').forEach(card => {
      card.hidden = state === 'hidden';
      if (card.hidden) return;
      const title = card.querySelector('[data-ntc-sample-title]');
      const titleText = text[state];
      if (title.textContent !== titleText) title.textContent = titleText;
      const detail = card.querySelector('[data-ntc-sample-detail]');
      const pending = ['checking', 'adding', 'removing'].includes(state);
      let detailText = text[state === 'added' ? 'detail' : pending ? 'pendingDetail' : state + 'Detail'];
      if(state==='added' && cfg.useApp){const amount=lastCart?.items.find(line=>line.variant_id===cfg.variantId)?.final_line_price ?? cfg.priceCents;detailText+=' · '+new Intl.NumberFormat(cfg.pl?'pl-PL':'en-GB',{style:'currency',currency:'PLN'}).format(amount/100);}
      if (detail.textContent !== detailText) detail.textContent = detailText;
      const button = card.querySelector('[data-ntc-sample-action]');
      button.hidden = pending;
      const buttonText = text[state === 'added' ? 'remove' : state === 'removed' ? 'add' : 'retry'];
      if (button.textContent !== buttonText) button.textContent = buttonText;
      button.disabled = busy;
    });
  }
  async function refresh(cart) {
    lastCart = cart;
    // Shopify returns the new HTML in the mutation response. Only retry if rendering failed.
    let sections = cart.sections;
    if (!sections?.['cart-items'] || !sections?.['cart-footer']) {
      sections = await request('?sections=' + sectionsBody({}).sections);
    }
    document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {bubbles:true, detail:{response:{...cart, sections}, ntcSample:true}}));
    document.dispatchEvent(new CustomEvent('baseline:cart:changed', {detail:{ntcSample:true}}));
    render();
  }
  async function removeGifts(cart, dismiss = false) {
    const updates = {};
    cart.items.filter(gift).forEach(line => { updates[line.key] = 0; });
    const body = {updates};
    if (dismiss) { remember(true); body.attributes = {[attr]:declineValue()}; }
    const result = await request('cart/update.js', sectionsBody(body));
    if (result.items.some(gift)) throw new Error('Sample removal not confirmed');
    previouslyPresent = false;
    lastCart = result;
    return result;
  }
  function verified(cart) {
    const samples = cart.items.filter(gift), sample = samples[0];
    return samples.length === 1 && sample.variant_id === cfg.variantId && sample.quantity === 1 && sample.original_line_price === cfg.priceCents &&
      sample.final_line_price >= 0 && sample.final_line_price <= cfg.priceCents;
  }
  function pricesByItem(cart) {
    const groups = new Map();
    for (const line of cart.items.filter(line => !gift(line))) {
      const properties = Object.entries(line.properties || {}).sort(([a], [b]) => a.localeCompare(b));
      const id = JSON.stringify([line.variant_id, properties, line.selling_plan_allocation?.selling_plan?.id]);
      const previous = groups.get(id) || {quantity:0, price:0};
      groups.set(id, {quantity:previous.quantity + line.quantity, price:previous.price + line.final_line_price});
    }
    return groups;
  }
  function preservedPrices(before, after) {
    const a = pricesByItem(before), b = pricesByItem(after);
    for (const [id, old] of a) {
      const current = b.get(id);
      if (current && old.quantity === current.quantity && current.price > old.price) return false;
    }
    return true;
  }
  async function sync(suppliedCart) {
    if (busy) { queued = true; return; }
    busy = true;
    const started = revision;
    let cart;
    try {
      await appSettings();
      // Membership starts on page load and runs in parallel with any necessary cart read.
      const member = membership();
      member.catch(() => {});
      cart = fullCart(suppliedCart) ? suppliedCart : await request('cart.js');
      lastCart = cart;
      // Retire sample lines and codes from the earlier discount-based pilot once.
      if (cart.items.some(legacyGift) || (cart.discount_codes || []).some(d => ownCodes.includes(d.code.toUpperCase()))) {
        const updates = {};
        cart.items.filter(legacyGift).forEach(line => { updates[line.key] = 0; });
        cart = await request('cart/update.js', sectionsBody({updates, discount:codes(cart)}));
        lastCart = cart;
        await refresh(cart);
      }
      if(cart.items.some(line=>gift(line) && line.variant_id!==cfg.variantId)){cart=await removeGifts(cart);previouslyPresent=false;await refresh(cart);}
      let gifts = cart.items.filter(gift);
      if (previouslyPresent && !gifts.length && otherProduct(cart)) {
        remember(true);
        cart = await removeGifts(cart, true);
      }
      const candidate = cfg.enabled && cart.currency === 'PLN' && cfg.available && otherProduct(cart) && cfg.customerId && cfg.tagEligible && cfg.subscribed && !cfg.used && cfg.historyComplete;
      if (candidate && !gifts.length && !declined(cart) && !blocked) { state = 'checking'; render(); }
      const eligible = candidate && await member;
      // A newer cart response arrived while checking membership; do not act on old data.
      if (started !== revision) { queued = true; return; }
      if (!eligible) {
        state = 'hidden';
        if (gifts.length) { cart = await removeGifts(cart); await refresh(cart); }
        return;
      }
      if (declined(cart)) {
        state = 'removed';
        if (gifts.length) {
          cart = await removeGifts(cart, true); await refresh(cart);
        }
        return;
      }
      if (blocked) return;
      if (verified(cart)) { previouslyPresent = true; state = 'added'; return; }
      const before = cart;
      if (!gifts.length) {
        state = 'adding'; render();
        const response = await request('cart/add.js', sectionsBody({items:[{id:cfg.variantId, quantity:1, properties:{_ntc_sample_campaign:campaign}}]}));
        cart = cartFromResponse(response) || await request('cart.js');
      } else {
        const updates = {};
        gifts.forEach((line, index) => { updates[line.key] = index === 0 ? 1 : 0; });
        cart = await request('cart/update.js', sectionsBody({updates}));
      }
      lastCart = cart;
      if (!verified(cart) || !preservedPrices(before, cart)) {
        blocked = true;
        const conflict = !preservedPrices(before, cart);
        cart = await removeGifts(cart);
        state = conflict ? 'conflict' : 'failed';
        await refresh(cart);
        return;
      }
      previouslyPresent = true; state = 'added';
      await refresh(cart);
    } catch (error) {
      blocked = true; state = 'failed';
      try {
        const current = await request('cart.js');
        lastCart = current;
        if (current.items.some(gift)) {
          cart = await removeGifts(current); await refresh(cart);
        }
      } catch { state = 'removeFailed'; }
      console.warn('[Nous Tous Club] Sample benefit unavailable');
    } finally {
      busy = false; render();
      if (started !== revision) pendingCart = null;
      if (queued) { queued = false; schedule(); }
    }
  }
  function schedule(cart) {
    if (fullCart(cart)) pendingCart = cart;
    clearTimeout(timer);
    timer = setTimeout(() => { const next = pendingCart; pendingCart = null; sync(next); }, 0);
  }
  function cartChanged(event) {
    if (event.detail?.ntcSample) return;
    revision++;
    const response = event.detail?.response;
    lastCart = cartFromResponse(response);
    pendingCart = lastCart;
    blocked = false;
    if (busy) queued = true;
    else schedule(lastCart);
  }
  async function dismiss() {
    if (busy) return;
    busy = true; state = 'removing'; remember(true); render();
    const rows = [...document.querySelectorAll('[data-line-item-key]')].filter(row => lastCart?.items.some(line => gift(line) && line.key === row.dataset.lineItemKey));
    rows.forEach(row => { row.hidden = true; });
    try {
      let result;
      try { result = await removeGifts(fullCart(lastCart) ? lastCart : await request('cart.js'), true); }
      catch { result = await removeGifts(await request('cart.js'), true); }
      state = 'removed'; await refresh(result);
    } catch {
      rows.forEach(row => { row.hidden = false; });
      state = 'removeFailed';
    } finally {
      busy = false; render();
      if (queued) { queued = false; schedule(); }
    }
  }
  window.NTCSamplePilot = {sync, dismiss};
  ['baseline:cart:afteradditem', 'baseline:cart:cartqtychange', 'baseline:cart:update'].forEach(name => window.addEventListener(name, cartChanged));
  window.addEventListener('cart-is-open', () => { settingsAt=0; if (!busy) schedule(fullCart(lastCart) ? lastCart : null); });
  document.addEventListener('baseline:cart:changed', event => { if (!event.detail?.ntcSample) cartChanged(event); });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ntc-sample-action]');
    if (!button || busy) return;
    event.preventDefault();
    if (state === 'added' || state === 'removeFailed') { await dismiss(); return; }
    busy = true;
    try {
      remember(false); blocked = false;
      const cart = await request('cart/update.js', {attributes:{[attr]:''}});
      pendingCart = cart;
    } catch { state = 'failed'; }
    finally { busy = false; render(); schedule(); }
  });
  // Both the benefit button and the normal row remove button use the same fast path.
  document.addEventListener('click', event => {
    const row = event.target.closest('[data-line-item-key]');
    const removeButton = event.target.closest('button, a');
    if (!row || removeButton?.getAttribute('@click.prevent') !== 'removeItem()') return;
    if (lastCart?.items.some(line => gift(line) && line.key === row.dataset.lineItemKey)) {
      event.preventDefault(); event.stopImmediatePropagation(); dismiss();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!(event.submitter?.name === 'checkout' || /\/checkout/.test(event.target.action || ''))) return;
    if (busy) {
      event.preventDefault();
      const form = event.target, submitter = event.submitter;
      const wait = setInterval(() => { if (!busy) { clearInterval(wait); form.requestSubmit(submitter); } }, 50);
    } else if (lastCart) {
      // Remove retired pilot codes from hidden fields without adding any sample code.
      event.target.querySelectorAll('input[name="discount"]').forEach(input => {
        const combined = new Set([...input.value.split(','), ...codes(lastCart).split(',')].filter(Boolean));
        for (const code of combined) if (ownCodes.includes(code.toUpperCase())) combined.delete(code);
        input.value = [...combined].join(',');
      });
    }
  }, true);
  new MutationObserver(render).observe(document.body, {childList:true, subtree:true});
  window.addEventListener('pageshow', event => {
    if (event.persisted) { lastCart = null; checkedAt = 0; eligibilityCheckedAt = 0; settingsAt=0; usedSharedStatus = true; schedule(); }
  });
  membership().catch(() => {});
  schedule(fullCart(lastCart) ? lastCart : null);
})();

